import React from "react";
import PropTypes from "prop-types";
import styles from "./CustomUpload.module.css";
import { Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const CustomUpload = ({
  error,
  handleBeforeUpload,
  fileName,
  label,
  accepts,
  showFileFormats,
  showRequired = false,
  showOptional = false,
}) => (
  <>
    <label htmlFor="file" className={styles.inputLabel}>
      {label}{" "}
      {showRequired ? (
        <span style={{ color: "red" }}>*</span>
      ) : showOptional ? (
        <span  style={{ color: "#8C8C8C" }}>
          {typeof showOptional === "string" ? ` ${showOptional}` : " (Optional)"}
        </span>
      ) : null}
      {showFileFormats && (
        <span className={styles.fileFormats}>
          ({accepts?.replace(/\./g, "").trim()})
        </span>
      )}
    </label>

    <Upload
      beforeUpload={handleBeforeUpload}
      showUploadList={false}
      accept={accepts}
      status={error ? "error" : ""}
      className={styles.common_input_styles}
    >
      <div
        className={styles.uploadContainer}
        style={{
          border: `1px solid ${error ? "red" : "#D0D5DD"}`,
        }}
      >
        <div className={styles.placeholderText}>
          {fileName ?? "Select a file to Upload"}
        </div>
        <UploadOutlined className={styles.uploadIcon} />
      </div>
    </Upload>
  </>
);

CustomUpload.propTypes = {
  error: PropTypes.bool,
  handleBeforeUpload: PropTypes.func.isRequired,
  fileName: PropTypes.string,
};

export default CustomUpload;
